export const ErrorTypes = {
  FieldError: 'FieldError',
  FormError: 'FormError',
  GeneralError: 'GeneralError',
  NetworkError: 'NetworkError',
  UnknownError: 'UnknownError',
  UnauthorizedError: 'UnauthorizedError',
} as const
export type ErrorTypes = typeof ErrorTypes
